import { useContext } from 'react';
import {
  PatientRequestContext,
  PatientRequestContextType,
} from './PatientRequestContext';

export const usePatientRequestContext = (): PatientRequestContextType => {
  const context = useContext(PatientRequestContext);
  if (!context) {
    throw new Error(
      'usePatientRequestContext must be used within a PatientRequestProvider',
    );
  }
  return context;
};
